import { RouteRecordRaw } from 'vue-router';

import { i18n } from '@/plugins/i18n';
import AppCardManagementView from '@/views/app/AppCardManagementView.vue';
import AppChatCreateView from '@/views/app/AppChatCreateView.vue';
import AppChatDetailListView from '@/views/app/AppChatDetailListView.vue';
import AppChatEditView from '@/views/app/AppChatEditView.vue';
import AppChatListView from '@/views/app/AppChatListView.vue';
import AppCreditManagementView from '@/views/app/AppCreditManagementView.vue';
import AppCustomerFaqView from '@/views/app/AppCustomerFaqView.vue';
import AppMainView from '@/views/app/AppMainView.vue';
import AppOnboardingStep1 from '@/views/app/AppOnboardingStep1.vue';
import AppOnboardingStep2 from '@/views/app/AppOnboardingStep2.vue';
import AppOnboardingStep3 from '@/views/app/AppOnboardingStep3.vue';
import AppSettingView from '@/views/app/AppSettingView.vue';
import AppSignupView from '@/views/app/AppSignupView.vue';
import AppSplashView from '@/views/app/AppSplashView.vue';
import AppTeamManageView from '@/views/app/AppTeamManageView.vue';
import AppTeamSetupView from '@/views/app/AppTeamSetupView.vue';
import AppTeamUserManageView from '@/views/app/AppTeamUserManageView.vue';
import AppUserInfoView from '@/views/app/AppUserInfoView.vue';
import AppWithdrawView from '@/views/app/AppWithdrawView.vue';
import AppLayout from '@/views/layout/AppLayout.vue';

export default function appRoutes(): RouteRecordRaw[] {
  return [
    {
      path: '/app',
      children: [
        {
          path: '',
          component: AppLayout,
          children: [
            {
              path: 'main',
              name: 'app-main-view',
              component: AppMainView,
              meta: { title: 'label_home' },
            },
            {
              path: 'chat/new/:type',
              name: 'app-chat-create',
              component: AppChatCreateView,
              props: true,
              meta: {
                title: (route) =>
                  `${i18n.global.t('label_' + route.params.type)} ${i18n.global.t('label_interpretation')}`,
              },
            },
            {
              path: 'chats',
              name: 'app-chat-list',
              component: AppChatListView,
              meta: { title: 'my_interpreter' },
            },
            {
              path: 'chats/detail',
              name: 'app-chats-detail',
              component: AppChatDetailListView,
              meta: { title: 'interpretation_history' },
            },
            {
              path: 'credit',
              name: 'app-credit',
              component: AppCreditManagementView,
              meta: { title: 'credit_history' },
            },
            {
              path: 'card',
              name: 'app-card',
              component: AppCardManagementView,
            },
          ],
        },
        {
          path: 'splash',
          name: 'app-splash',
          component: AppSplashView,
        },
        {
          path: 'signup',
          name: 'app-signup',
          component: AppSignupView,
        },
        {
          path: 'onboarding',
          children: [
            {
              path: 'step1',
              name: 'app-onboarding-step1',
              component: AppOnboardingStep1,
            },
            {
              path: 'step2',
              name: 'app-onboarding-step2',
              component: AppOnboardingStep2,
            },
            {
              path: 'step3',
              name: 'app-onboarding-step3',
              component: AppOnboardingStep3,
            },
          ],
        },
        {
          path: 'chat/:code',
          name: 'app-chat-edit',
          component: AppChatEditView,
          meta: { transition: 'slide-left' },
          props: true,
        },
        {
          path: 'setting',
          children: [
            {
              path: '',
              name: 'app-setting',
              component: AppSettingView,
              meta: { transition: 'slide-left' },
            },
            {
              path: 'customerfaq',
              name: 'app-customer-faq',
              component: AppCustomerFaqView,
              meta: { transition: 'slide-left' },
            },
            {
              path: 'team',
              children: [
                {
                  path: '',
                  name: 'app-team-manage',
                  component: AppTeamManageView,
                  meta: { transition: 'slide-left' },
                },
                {
                  path: 'setup',
                  name: 'app-team-setup',
                  component: AppTeamSetupView,
                  meta: { transition: 'slide-left' },
                },
                {
                  path: 'user/manage',
                  name: 'app-team-user-manage',
                  component: AppTeamUserManageView,
                  meta: { transition: 'slide-left' },
                },
              ],
            },
            {
              path: 'info',
              name: 'app-user-info',
              component: AppUserInfoView,
              meta: { transition: 'slide-left' },
            },
            {
              path: 'withdraw',
              name: 'app-user-withdraw',
              component: AppWithdrawView,
              meta: { transition: 'slide-left' },
            },
          ],
        },
        // TODO: 인앱 결제 기능 미구현으로 임시 비활성화했습니다. 결제 도입 시 주석 해제가 필요합니다.
        // {
        //   path: 'subscribe',
        //   name: 'native-subscribe',
        //   component: NativeSubscribeView,
        // },
        // {
        //   path: 'autocredit',
        //   name: 'native-autocredit',
        //   component: NativeAutoCreditView,
        //   meta: { transition: 'slide-left' },
        // },
        // {
        //   path: 'compare',
        //   name: 'native-compare',
        //   component: NativeChatCompareView,
        //   meta: { transition: 'slide-left' },
        // },
        // {
        //   path: 'creditbuy',
        //   name: 'native-creditbuy',
        //   component: NativeCreditBuyView,
        //   meta: { transition: 'slide-left' },
        // },
        // {
        //   path: 'payment',
        //   name: 'native-payment',
        //   component: NativePaymentView,
        //   meta: { transition: 'slide-left' },
        // },
      ],
    },
  ];
}
